import { Locale, type LocalizedString } from "../Locale.js";

export const helpSmallGoodsPathMap = {
	[Locale.cs]: "chci-skladovat-male-zbozi" as const,
} satisfies LocalizedString;
